const ENV = "DEV";
 
export const ALL_API = {
  // DEV_API_HOST: "http://182.77.59.45:5010",
  //  DEV_API_HOST: "http://122.160.157.197:5010",
  // DEV_API_HOST: "http://182.77.59.45:5011",
  // DEV_API_HOST: "http://182.77.59.45:5010",
  // DEV_API_HOST: "http://178.212.35.32:5011",
  // DEV_API_HOST: "http://182.77.59.45:5012",
  DEV_API_HOST: "https://api.railplot.com",
  // DEV_API_HOST: "http://127.0.0.1:5011",
 
  // DEV_API_HOST: "http://182.77.59.45:5011",
};
 
export const CONFIG = {
  BASE_URL: ALL_API[ENV + "_API_HOST"],
};
export default CONFIG;
 
export const baseUrl = `${CONFIG.BASE_URL}`;